export default __webpack_public_path__ + "static/Daniel-3e651dd7a57b6f57823bc52b74ea8c95.jpg";